import React from 'react';

const FormField = ({ label, required = false, submitted = false, error = false, errorMessage, children, className = 'col-12 md:col-4' }) => {
    const hasError = submitted && required && error;

    return (
        <div className={className}>
            <div className="field">
                <label htmlFor={label} className="font-bold block mb-2">
                    {label} {required && '*'}
                </label>
                <div className={hasError ? 'p-invalid' : ''}>{children}</div>
                {hasError && <small className="p-error">{errorMessage || 'This field is required'}</small>}
            </div>
        </div>
    );
};

export default FormField;
